import { Media } from "./media.model";

export class VariantValuesDTO {
    name: string;
    images: Media[];

    constructor(
        name: string = "",
        images: Media[] = [],
    ) {
        this.name = name;
        this.images = images;
    }
}

export class Variants {
    type: string;
    subType: string;
    values: VariantValuesDTO[];
    // for frontend
    allowImages?: boolean = false;
    options?:any[] = [];
    fromManual?: boolean;

    constructor(
        type: string = "",
        subType: string = "",
        values: VariantValuesDTO[] = [],
    ) {
        this.type = type;
        this.subType = subType;
        this.values = values;
    }
}